import { render, staticRenderFns } from "./Clench.vue?vue&type=template&id=3e3a83be&scoped=true&"
import script from "./Clench.vue?vue&type=script&lang=js&"
export * from "./Clench.vue?vue&type=script&lang=js&"
import style0 from "./Clench.vue?vue&type=style&index=0&id=3e3a83be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a83be",
  null
  
)

export default component.exports